<template>
  <b-container fluid>
    <div>
      <b-card
        style='border: none'>
        <b-card-title>
          Welcome to Curate!  Please input your information here so you can
          curate your website.
        </b-card-title>
          <b-card-body>
            <b-list-group>
              <b-list-group-item style='border: none'>
                <b-form>
                  <b-form-group>
                    <label for="landing_page_message">
                      <h5 class="mb-1">Landing Page Message</h5>
                      <p>
                        What message do you want your viewers to see first?
                      </p>
                    </label>
                    <b-form-textarea
                    type="text"
                    id="landing_page_message"
                    rows="3"
                    required
                    v-model="info.landing_page_message"></b-form-textarea>
                  </b-form-group>
                </b-form>
              </b-list-group-item>
              <b-list-group-item style='border: none'>
                <b-form>
                  <b-form-group>
                    <label for="about_me">
                      <h5 class="mb-1">About Me</h5>
                      <p>
                        What do you want to share with your viewers?
                      </p>
                    </label>
                    <b-form-textarea
                    type="text"
                    id="about_me"
                    rows="3"
                    required
                    v-model="info.about_me"></b-form-textarea>
                  </b-form-group>
                </b-form>
              </b-list-group-item>
            </b-list-group>
          </b-card-body>
      </b-card>
    </div>
    <div>
      <b-card-group deck>
        <b-card style='border: none'>
          <b-card-title>
            <h5>Advisers</h5>
            <small>
              Do you have a set of people that advises you?
            </small>
          </b-card-title>
          <b-card-body>
            <b-list-group>
              <AdviserAdvisee
              v-for="(item, index) in info.adviser"
              v-bind:data="item"
              v-on:delete-row="deleteAdviser(index)"
              v-bind:key="item.advisorID"></AdviserAdvisee>
            </b-list-group>
          </b-card-body>
          <b-card-footer>
            <small class='text-muted'>
              <b-button v-b-modal.modal-adviser-add>Add Adviser</b-button>
            </small>
            <b-modal id="modal-adviser-add" hide-footer>
              <b-form @submit="addAdviser">
                <AdviserAdviseeForm :data="form.adviser"></AdviserAdviseeForm>
                <b-button type="submit" variant="primary">Submit</b-button>
              </b-form>
            </b-modal>
          </b-card-footer>
        </b-card>

        <b-card style='border: none'>
          <b-card-title>
            <h5>Advisees</h5>
            <small>
              Do you have a set of people that you advise?
            </small>
          </b-card-title>
          <b-card-body>
            <b-list-group>
              <AdviserAdvisee
              v-for="(item, index) in info.advisee"
              v-bind:data="item"
              v-on:delete-row="deleteAdvisee(index)"
              v-bind:key="item.advisorID"></AdviserAdvisee>
            </b-list-group>
          </b-card-body>
          <b-card-footer>
            <small class='text-muted'>
              <b-button v-b-modal.modal-advisee-add>Add Advisee</b-button>
            </small>
            <b-modal id="modal-advisee-add" hide-footer>
              <b-form @submit="addAdvisee">
                <AdviserAdviseeForm :data="form.advisee"></AdviserAdviseeForm>
                <b-button type="submit" variant="primary">Submit</b-button>
              </b-form>
            </b-modal>
          </b-card-footer>
        </b-card>
      </b-card-group>
    </div>
    <div>
      <b-card-group deck>
        <b-card style='border: none'>
          <b-card-title>
            <h5>Education</h5>
            <small>
              What are your educational feats?
            </small>
          </b-card-title>
          <b-card-body>
            <b-list-group>
              <Education
              v-for="(item, index) in info.education"
              v-bind:data="item"
              v-on:delete-row="deleteEducation(index)"
              v-bind:key="item.educationID"></Education>
            </b-list-group>
          </b-card-body>
          <b-card-footer>
            <small class='text-muted'>
              <b-button v-b-modal.modal-education-add>Add Education</b-button>
            </small>
            <b-modal id="modal-education-add" hide-footer>
            <b-form @submit="addEducation">
              <EducationForm :data="form.education"></EducationForm>
              <b-button type="submit" variant="primary">Submit</b-button>
            </b-form>
            </b-modal>
          </b-card-footer>
        </b-card>

        <b-card style='border: none'>
          <b-card-title>
            <h5>Work Experience</h5>
            <small>
              Where have you worked?
            </small>
          </b-card-title>
          <b-card-body>
            <b-list-group>
              <WorkExperience
              v-for="(item, index) in info.work_experience"
              v-bind:data="item"
              v-on:delete-row="deleteWorkExperience(index)"
              v-bind:key="item.jobID"></WorkExperience>
            </b-list-group>
          </b-card-body>
          <b-card-footer>
            <small class='text-muted'>
              <b-button v-b-modal.modal-job-add>Add Work Experience</b-button>
            </small>
            <b-modal id="modal-job-add" hide-footer>
              <b-form @submit="addWorkExperience">
                <JobForm :data="form.work_experience"></JobForm>
                <b-button type="submit" variant="primary">Submit</b-button>
              </b-form>
            </b-modal>
          </b-card-footer>
        </b-card>

        <b-card style='border: none'>
          <b-card-title>
            <h5>Publicaitons</h5>
            <small>
              What are some publications you were listed as an author?
            </small>
          </b-card-title>
          <b-card-body>
            <b-list-group>
              <Publication
              v-for="(item, index) in info.publication"
              v-bind:data="item"
              v-on:delete-row="deletePublication(index)"
              v-bind:key="item.publicationID"></Publication>
            </b-list-group>
          </b-card-body>
          <b-card-footer>
            <small class='text-muted'>
              <b-button v-b-modal.modal-publication-add>Add Publication</b-button>
            </small>
            <b-modal id="modal-publication-add" hide-footer>
              <b-form @submit="addPublication">
                <PublicationForm :data="form.publication"></PublicationForm>
                <b-button type="submit" variant="primary">Submit</b-button>
              </b-form>
            </b-modal>
          </b-card-footer>
        </b-card>
      </b-card-group>

      <b-card style='border: none'>
        <b-card-title>
          <h5>Skills</h5>
          <small>
            What are some your professional skills?
          </small>
        </b-card-title>
        <b-card-body>
          <b-list-group>
            <Skill
            v-for="(item, index) in info.skills"
            v-bind:data="item"
            v-on:delete-row="deleteSkill(index)"
            v-bind:key="item.skillID"></Skill>
          </b-list-group>
        </b-card-body>
        <b-card-footer>
          <small class='text-muted'>
            <b-button v-b-modal.modal-skill-add>Add Skill</b-button>
          </small>
          <b-modal id="modal-skill-add" hide-footer>
            <b-form @submit="addSkill">
              <SkillForm :data="form.skill"></SkillForm>
              <b-button type="submit" variant="primary">Submit</b-button>
            </b-form>
          </b-modal>
        </b-card-footer>
      </b-card>

    </div>

    <b-button v-on:click="saveFile" variant="primary">Download</b-button>

    <b-modal id="checkout-form" hide-footer>
      <b-form
        action="https://formspree.io/f/xdoplnlq"
        method="POST"
      >

        <label>
          Your Feedback:
          <b-form-textarea name="message"></b-form-textarea>
        </label>

        <!-- your other form fields go here -->
        <label for="app-rating">How Would You Rate This App? (between 1 and 5):</label>
        <b-form-input type="number" id="app-rating" name="app-rating" min="1" max="5"/>

        <label for="recommend">Would You Recommend This App?</label>
        <b-form-checkbox id="recommend" name="recommend" value="yes">Yes?</b-form-checkbox>

        <b-button type="submit">Send</b-button>
      </b-form>
    </b-modal>

  </b-container>
</template>
<script>
/* eslint-disable */
import { saveAs } from 'file-saver';
import Vue from 'vue';

import { FormCheckboxPlugin, ProgressPlugin, FormRatingPlugin, FormTextareaPlugin, FormPlugin, FormInputPlugin, FormGroupPlugin, ModalPlugin, ListGroupPlugin, ButtonPlugin, LayoutPlugin, CardPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

const Education = () => import('./input/Education');
const WorkExperience = () => import('./input/WorkExperience');
const Publication = () => import('./input/Publication');
const AdviserAdvisee = () => import('./input/AdviserAdvisee');
const Skill = () => import('./input/Skill');
const EducationForm = () => import('./form/EducationForm');
const SkillForm = () => import('./form/SkillForm');
const JobForm = () => import('./form/JobForm');
const PublicationForm = () => import('./form/PublicationForm');
const AdviserAdviseeForm = () => import('./form/AdviserAdviseeForm');

Vue.use(ListGroupPlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(ModalPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormGroupPlugin);
Vue.use(LayoutPlugin);
Vue.use(CardPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(FormRatingPlugin);
Vue.use(ProgressPlugin);
Vue.use(FormCheckboxPlugin);

const default_form_values = {
  education: {
    university: '',
    degree: '',
    major: '',
    graduationDate: null,
    startDate: null
  },
  publication: {
    publicationTitle: '',
    editorial: '',
    publicationURL: '',
    publicationDate: null
  },
  work_experience: {
    jobTitle: '',
    companyName: '',
    startDate: null,
    endDate: null
  },
  adviser: {
    title: '',
    firstName: '',
    lastName: '',
    url: ''
  },
  advisee: {
    title: '',
    firstName: '',
    lastName: '',
    url: ''
  },
  skill: {
    skillName: '',
    skillRating: 0
  }
};

function generate_ed_html(data){
  return String.raw`<div class='row' id='${data.educationID}'>
    <div class='col'>
      <h6 class='mb-1'>
        ${data.university}, ${data.degree}, ${data.major}
      </h6>
    </div>
    <div class='col'>
      <p class='mb-1'>
        From ${data.startDate} - ${data.graduationDate}
      </p>
    </div>
  </div>`;
}

function generate_job_html(data){
  return String.raw`<div class='row' id='${data.jobID}'>
    <div class='col'>
      <h6 class='mb-1'>
        ${data.jobTitle}, ${data.companyName}
      </h6>
    </div>
    <div class='col'>
      <h6 class='mb-1'>
        ${data.startDate} - ${data.endDate}
      </h6>
    </div>
  </div>`;
}

function generate_pub_html(data){
  return String.raw`<div class='row id='${data.publicationID}'>
    <div class='col'>
      <h6 class='mb-1'>
        ${data.publicationTitle}
      </h6>
    </div>
    <div class='col'>
      <p>
        Editorial: ${data.editorial}
      </p>
    </div>
    <div class='col'>
      <p>Published on: ${data.publicationDate}</p>
      <p>Publication URL: ${data.publicationURL}</p>
    </div>
  </div>`;
}

function generate_ad_html(data){
  return String.raw`<div class='row' id='${data.advisorID}'>
    <h6 class='mb-1'>
      <a href=${data.url}>${data.title} ${data.firstName} ${data.lastName}</a>
    </h6>
  </div>`;
}

function get_rating_html(rating){
  const star = '<span class="fa fa-star checked"></span>';
  const no_star = '<span class="fa fa-star"></span>';

  return star.repeat(rating).concat("", no_star.repeat(5 - rating));
}

function generate_skill_html(data){
  return String.raw`
  <div class='row' id='${data.skillID}'>
    <div class='col'>
      <span>Skill - </span><span>${data.skillName}: </span>
    </div>
    <div class='col'>
      ${get_rating_html(data.skillRating)}
    </div>
  </div>
  `;
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default {
  name: 'Account',
  components: {
    Education,
    WorkExperience,
    Publication,
    AdviserAdvisee,
    Skill,
    SkillForm,
    EducationForm,
    JobForm,
    PublicationForm,
    AdviserAdviseeForm
  },
  data() {
    return {
      form: default_form_values,
      info: {
        education: [],
        work_experience: [],
        publication: [],
        adviser: [],
        advisee: [],
        landing_page_message: 'Welcome!',
        about_me: 'This page will briefly describe all of my amazing achievements.',
        skills: [],
      },
    }
  },
  methods: {
    async addSkill(evt) {
      evt.preventDefault();

      var _skill = this.form.skill;
      _skill.skillID = uuidv4();

      this.info.skills.push(_skill);
      this.form.skill = {
        skillName: '',
        skillRating: 0
      };
    },
    async addEducation(evt) {
      evt.preventDefault();

      var _education = this.form.education;
      _education.educationID = uuidv4();

      this.info.education.push(_education);
      this.form.education = {
        university: '',
        degree: '',
        major: '',
        graduationDate: null,
        startDate: null
      };
    },
    async addWorkExperience(evt) {
      evt.preventDefault();

      var _work_experience = this.form.work_experience;
      _work_experience.jobID = uuidv4();

      this.info.work_experience.push(_work_experience);
      this.form.work_experience = {
        jobTitle: '',
        companyName: '',
        startDate: null,
        endDate: null
      };
    },
    async addPublication(evt){
      evt.preventDefault();

      var _publication = this.form.publication;
      _publication.publicationID = uuidv4();

      this.info.publication.push(_publication);
      this.form.publication = {
        publicationTitle: '',
        editorial: '',
        publicationURL: '',
        publicationDate: null
      };
    },
    async addAdviser(evt){
      evt.preventDefault();

      const _data = {
        advisorID: uuidv4(),
        title: this.form.adviser.title,
        firstName: this.form.adviser.firstName,
        lastName: this.form.adviser.lastName,
        url: this.form.adviser.url
      };

      this.info.adviser.push(
        _data
        );

      this.form.adviser = {
        title: '',
        firstName: '',
        lastName: '',
        url: ''
      };

    },
    async addAdvisee(evt){
      evt.preventDefault();

      var _advisee = this.form.advisee;
      _advisee.advisorID = uuidv4();

      this.info.advisee.push(_advisee);
      this.form.advisee = {
        title: '',
        firstName: '',
        lastName: '',
        url: ''
      };
    },
    async saveFile(evt) {

      var final_ed = '';
      var final_job = '';
      var final_pub= '';
      var final_adviser = '';
      var final_advisee = '';
      var final_skills = '';

      const generate_row_html = (raw_data, mapper, header_name) => String.raw`
      <div class='row text-center'>
        <h2 class='text-center'>${header_name}</h2>
      </div>
      ${raw_data.map(mapper).join(' ')}
      `

      if (0 < this.info.education.length){
        final_ed = String.raw`
        <div class='col'>
          ${generate_row_html(this.info.education, generate_ed_html, 'Education')}
        </div>
        `;
      } else{
        console.log("skipping education")
      }

      if (0 < this.info.work_experience.length){
        final_job = String.raw`
        <div class='col'>
          ${generate_row_html(this.info.work_experience, generate_job_html, 'Work Experience')}
        </div>
        `;
      } else{
        console.log("skipping work experience")
      }

      if (0 < this.info.publication.length){
        final_pub = String.raw`
        <div class='col'>
          ${generate_row_html(this.info.publication, generate_pub_html, 'Publications')}
        </div>
        `;
      } else{
        console.log("skipping publication")
      }

      if (0 < this.info.adviser.length){
        final_adviser = String.raw`
        <div class='col'>
          ${generate_row_html(this.info.adviser, generate_ad_html, 'Advisers')}
        </div>
        `;
      } else{
        console.log("skigging adviser")
      }

      if (0 < this.info.advisee.length){
        final_advisee = String.raw`
        <div class='col'>
          ${generate_row_html(this.info.advisee, generate_ad_html, 'Advisees')}
        </div>
        `;
      } else{
        console.log("skipping advisee")
      }

      if (0 < this.info.skills.length){
        final_skills = String.raw`
        <div class='col'>
          ${generate_row_html(this.info.skills, generate_skill_html, 'Your Skills')}
        </div>

        `;
      } else{
        console.log("skipping skills")
      }

      const _html = String.raw`
      <html>
      <head>
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css" integrity="sha384-TX8t27EcRE3e/ihU7zmQxVncDAy5uIKz4rEkgIXeMed4M0jlfIDPvg6uqKI2xXr2" crossorigin="anonymous">
      <style>
        .checked {
          color: orange;
        }
        .container {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }
        .container .row {
          padding: 5px;
        }
      </style>
      </head>
      <body>
      <div class='container align-content-around'>
        <div class='jumbotron'>
          <h1>
            ${this.info.landing_page_message}
          </h1>
          <p class='lead'>
            ${this.info.about_me}
          </p>
        </div>
        <div class='row'>
          ${final_adviser}
        </div>
        <div class='row'>
          ${final_advisee}
        </div>
        <div class='row'>
          ${final_ed}
        </div>
        <div class='row'>
          ${final_job}
        </div>
        <div class='row'>
          ${final_pub}
        </div>
        <div class='row'>
          ${final_skills}
        </div>
        <div class='row'>
          <small>Curated by <a href="https://www.pyscale.net">PyScale, LLC</a></small>
        </div>
      </div>
      </body>
      </html>
      `

      var blob = new Blob([_html],
                { type: "text/plain;charset=utf-8" });
      saveAs(blob, "index.html");

      this.$bvModal.show('checkout-form');

    },
    async deleteEducation(index) {
      this.info.education.splice(index, 1);
    },
    async deleteWorkExperience(index) {
      this.info.work_experience.splice(index, 1);
    },
    async deletePublication(index) {
      this.info.publication.splice(index, 1);
    },
    async deleteAdviser(index) {
      this.info.adviser.splice(index, 1);
    },
    async deleteAdivsee(index) {
      this.info.advisee.splice(index, 1);
    },
    async deleteSkill(index) {
      this.info.skills.splice(index, 1);
    },
  },
}

</script>



// WEBPACK FOOTER //
// src/components/Account.vue